// 判断是否需要需要禁用Hotkey
// return true or false
// true:需要禁用
export default target => {
  // 编辑器类名称
  if (target.className === "notranslate public-DraftEditor-content") {
    return true;
  }
  return false;
};
